<template>
	<div class="equipment">
		<transition name="equipment" mode="out-in">
			<div v-if="equipment" :key="equipment.id" class="equipment-content">
				<div class="illustration">
					<div class="img" v-bg="'cards/' + equipment.type + '/' + equipment.slug + '.png'"></div>
				</div>
				<transition-group name="durability" class="durability" tag="div" mode="out-in">
					<div v-for="i in equipment_durability" :key="i" class="dot"></div>
				</transition-group>

				<ui-tooltip v-if="equipment[lang]" :title="equipment[lang].name" :text="equipment[lang].description" :value="main_value" />
			</div>
		</transition>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UiTooltip from '@/components/ui/ui-tooltip'
import { get_card_value } from '@/js/board'

export default {
	name: 'equipment',
	props: {
		equipment: { default: null }
	},
	computed: {
		...mapGetters([ 'lang' ]),
		main_value() {
			if (this.equipment.type === 'shield') return get_card_value(this.equipment, 'armor')
			if (this.equipment.type === 'weapon') return get_card_value(this.equipment, 'attack')
			return 0
		},
		equipment_durability() {
			return get_card_value(this.equipment, 'durability')
		}
	},
	components: { UiTooltip }
}
</script>

<style lang="stylus" scoped>

.equipment
	width 72px
	height 72px
	&:before
		content ''
		absolute 10px
		background-color #222
		border-radius 4px
		transform rotate(45deg)
		border 3px solid #fff
	.equipment-content
		absolute 0
		&:hover
			>>> .ui-tooltip
				visibility visible
		&.equipment-enter-active
			transition 0.4s easeOutQuart
		&.equipment-leave-active
			transition 0.4s easeInQuart
		&.equipment-enter
			transform translateY(-50%) scale(1.5)
			opacity 0
		&.equipment-leave-to
			transform translateY(100%) scale(0.8)
			opacity 0
		.illustration
			absolute 0
			.img
				absolute 4px
				background center center no-repeat
				background-size contain
		.durability
			position absolute
			left 0
			right 0
			top calc(100% + 8px)
			height 16px
			flex center center
			.dot
				width 12px
				height 12px
				margin 0 2px
				border-radius 50%
				background-color #fff
				transition 0.25s easeOutQuart
				&.durability-enter
					transform translateY(-24px)
				&.durability-leave-to
					transform translateY(24px)
					opacity 0

</style>
